module.exports = __webpack_public_path__ + "static/fanalyzeLogo-6ba2c65840a950a6d911b6be712d025a.png";